export type ReportThumbnailDisplay =
  | { kind: 'hidden' }
  | { kind: 'pending' }
  | { kind: 'empty' }
  | { kind: 'ready'; url: string };

/**
 * Rail slot for one page. `undefined` means capture has not finished; `null`
 * means it finished without an image.
 */
export const getReportThumbnailDisplay = (
  visibleIndex: number | null,
  url: string | null | undefined,
): ReportThumbnailDisplay => {
  if (visibleIndex === null) return { kind: 'hidden' };
  if (url) return { kind: 'ready', url };
  if (url === null) return { kind: 'empty' };
  return { kind: 'pending' };
};
